// extracted by mini-css-extract-plugin
export default {"jobInfoContainer":"JobInfoSection_jobInfoContainer__6ZTC0"};